import axios from './index';

// Bootstrap: centros del usuario autenticado + su centro por defecto
export const getMyMedicalCenters = () => axios.get('api/v1/medicalcenter/me');

// CRUD de centros (Settings)
export const getMedicalCenters = (tenantId = null) => {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return axios.get(`api/v1/medicalcenter${params}`);
};
export const getMedicalCenter = (id, tenantId = null) => {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return axios.get(`api/v1/medicalcenter/${id}${params}`);
};
export const createMedicalCenter = (data, tenantId = null) => {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return axios.post(`api/v1/medicalcenter${params}`, data);
};
export const editMedicalCenter = (id, data, tenantId = null) => {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return axios.put(`api/v1/medicalcenter/${id}${params}`, data);
};
export const removeMedicalCenter = (id, tenantId = null) => {
    const params = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return axios.delete(`api/v1/medicalcenter/${id}${params}`);
};

// Actualiza la asignación de centros de un usuario
export const updateUserCenters = (userId, data) => axios.put(`api/v1/users/${userId}/centers`, data);
